import { createAction } from '@reduxjs/toolkit';

export const setSkuData = createAction('SET_SKU_DATA');
export const updateSkuData = createAction('UPDATE_SKU_DATA');
export const updateSkuDataProperty = createAction('UPDATE_SKU_DATA_PROPERTY');